import { CssBaseline } from '@mui/material';
import LogRocket from 'logrocket';
import ReactDOM from 'react-dom/client';
import { Provider } from 'react-redux';
import App from './app';
import AppTheme from './app-theme';
import { store } from './features/store.redux';
import './index.css';
import ConfigService from './services/config.service';
import AppMsal from './app-msal';

// Log Rocket
LogRocket.init(ConfigService.appConfig.logRocketId, {
    network: {
        requestSanitizer: (request) => {
            // Do not log bearer token
            if (request.headers.Authorization) {
                request.headers.Authorization = request.headers.Authorization.replace(/Bearer\s.+/, 'Bearer [REDACTED]');
            }
            return request;
        }
    }
});

const root = ReactDOM.createRoot(document.getElementById('root') as HTMLElement);

root.render(
    <AppTheme>
        <CssBaseline />
        <Provider store={store}>
            <AppMsal>
                <App />
            </AppMsal>
        </Provider>
    </AppTheme>
);

document.querySelector('#root');
